import DefaultLoading from 'src/components/Common/Loading'
import { LoadingWrapper } from './styles'

const Loading = () => (
  <LoadingWrapper>
    <DefaultLoading />
  </LoadingWrapper>
)

export default Loading
